import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';
import { IWithFullPrice } from '@core/models/modals';
import { MbDialogRef, MB_DIALOG_DATA, MbDialogBody } from '@am/moebius';

// TODO: No se usa
@Component({
  selector: 'app-modal-with-full-price',
  standalone: true,
  imports: [CommonModule, MbDialogBody],
  templateUrl: './with-full-price.component.html',
  styleUrls: ['./with-full-price.component.scss'],
})
export class ModalWithFullPriceComponent
  extends DialogWrapperComponent
  implements AfterViewInit, OnInit
{
  public information: string;
  public arrow: string;
  public arrowType: string;

  constructor(
    private dialogRef: MbDialogRef<ModalWithFullPriceComponent>,
    @Inject(MB_DIALOG_DATA) public dialogData: IWithFullPrice,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.arrowType = this.dialogData.view === 'detail' ? 'arrow-detail' : 'arrow';
    this.information = `/hotels/dist/es-AR/browser/assets/images/information.svg`;
    this.arrow = `/hotels/dist/es-AR/browser/assets/images/${this.arrowType}.svg`;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.dialogRef.close();
    }, 7000);
  }
}
